import { Component, signal, OnInit, Inject, inject, PLATFORM_ID } from '@angular/core';
import { Router, RouterOutlet, Event, NavigationStart, NavigationEnd, NavigationCancel, NavigationError } from '@angular/router';
import { TenantService } from './core/tenant/tenant';
import { Title, Meta } from '@angular/platform-browser';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { TenantConfigService } from './core/config/tenant-config';
import { Header } from "./shared/components/header/header";
import { StateService } from './core/services/state.service';
import { Footer } from "./shared/components/footer/footer";
import { OrderSelectionService } from './core/services/order-selection.service';
import { OrderProcessingService } from './core/services/order-processing';
import { StorageTimeoutService } from './core/services/storage-timeout.service';
import { FedexService } from './core/services/fedex';
import { AutoComplete } from './core/services/client-service/auto-complete/auto-complete';
import { VersionCheckService } from './core/services/version-check.service';

@Component({
    selector: 'app-root',
    imports: [RouterOutlet, Header, Footer],
    templateUrl: './app.html',
    styleUrl: './app.scss'
})
export class App {
    public settings: any = null;

    readonly stateCode = inject(StateService).stateCode;
    readonly isOrderPage = inject(StateService).isOrderPage;
    readonly sidebarSection = inject(StateService).sidebarSection;
    readonly hasSidebar = inject(StateService).hasSidebar;
    readonly orderSelection = inject(OrderSelectionService);
    readonly orderProcessing = inject(OrderProcessingService);
    readonly storageTimeout = inject(StorageTimeoutService);
    readonly fedexService = inject(FedexService);
    readonly autoCompleteService = inject(AutoComplete);
    readonly versionCheck = inject(VersionCheckService);

    constructor(private tenant: TenantService, private configService: TenantConfigService, private titleService: Title,
        @Inject(DOCUMENT) private document: Document
    ) {
        this.tenant.getDomain();

        this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationStart) {
                this.isRouting.set(true);
            } else if (
                event instanceof NavigationEnd ||
                event instanceof NavigationCancel ||
                event instanceof NavigationError
            ) {
                this.isRouting.set(false);
                if (event instanceof NavigationError) {
                    const errorMsg = (event.error?.message || event.error?.toString() || '').toLowerCase();
                    if (
                        errorMsg.includes('loading chunk') ||
                        errorMsg.includes('failed to fetch dynamically imported module') ||
                        errorMsg.includes('importing a module script failed')
                    ) {
                        this.versionCheck.triggerUpdateModal();
                    }
                }
                if (event instanceof NavigationEnd) {
                    const url = event.urlAfterRedirects.split('?')[0];
                    this.isHomeRoute.set(url === '/' || url === '/home');
                }
            }
        });
    }
    
    public readonly isRouting = signal(false);
    public readonly isHomeRoute = signal(false);
    // protected readonly title = signal('embassy')
    // ;

    private router = inject(Router);
    private platformId = inject(PLATFORM_ID);
    private meta = inject(Meta);



    ngOnInit() {
        // Retrieve the settings that were already loaded during APP_INITIALIZER
        this.settings = this.configService.settings;
        const settings = this.settings;

        // Set the title if it exists in the API response
        if (settings && settings.title) {
            this.titleService.setTitle(settings.title);
        }

        // Set Google Search Console verification tag
        if (settings && settings.seo_search_console) {
            let content = settings.seo_search_console;
            const match = content.match(/content=["']([^"']+)["']/i);
            if (match && match[1]) {
                content = match[1];
            }
            this.meta.updateTag({ name: 'google-site-verification', content: content });
        }

        // NOTE: Favicon and theme are already applied by TenantConfigService
        // during APP_INITIALIZER — no need to duplicate here.
    }
}
